export default "__VITE_ASSET__BPSfUh1R__"